import React, { forwardRef } from 'react';

interface Hamburger2Props {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const Hamburger2 = forwardRef<HTMLElement, Hamburger2Props>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-bars ${classes || ''}`} style={style}></i>
  );
});

Hamburger2.displayName = 'Hamburger2';